<template>
  <el-container>
    <el-header>
      <el-row align="middle">
        <el-col :span="1">
          <img :src="require('@/assets/svg/users.svg')" />
        </el-col>
        <el-col :span="23">
          <span class="title-header">Personalizar Menú de Usuario</span>
        </el-col>
      </el-row>
    </el-header>

    <section>
      <el-form
        ref="formUser"
        :model="form"
        :rules="rules"
        label-position="top"
        label-width="auto"
      >
        <el-row :gutter="20" justify="space-between">
          <el-col :span="8">
            <el-row>
              <el-col>
                <el-form-item label="Usuario" prop="usua_id">
                  <el-select
                    filterable
                    v-model="form.usua_id"
                    placeholder=""
                    @change="isProfile"
                  >
                    <el-option
                      v-for="(option, index) in usersOptions"
                      :key="index"
                      :label="option.usua_nombre + ' ' + option.usua_apellido"
                      :value="option.usua_id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item
                  v-if="form.usua_id && !isUserProfile"
                  label="Este usuario no tiene un perfil asignado, por favor seleccione uno:"
                  prop="arpe_id"
                >
                  <el-select
                    v-model="form.arpe_id"
                    placeholder=""
                    @change="loadMenuByProfile"
                  >
                    <el-option
                      v-for="(option, index) in profileOptions"
                      :key="index"
                      :label="option.arpe_nombre"
                      :value="option.arpe_id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-else-if="form.arpe_id"
                  label="Perfil asignado al usuario:"
                  prop="arpe_id"
                >
                  <el-select v-model="form.arpe_id" placeholder="">
                    <el-option
                      v-for="(option, index) in profileOptions"
                      :key="index"
                      :label="option.arpe_nombre"
                      :value="option.arpe_id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-button
                  :disabled="!form.arpe_id || !form.usua_id"
                  type="primary"
                  @click="onsubmit"
                >
                  Crear
                </el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="16">
            <el-form-item
              v-if="form.usua_id && form.arpe_id"
              :label="'Por favor modifique el menú para el usuario:'"
            >
              <el-aside style="height: 77vh">
                <build :items="menu" />
              </el-aside>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <dialog-confirm
      title="Guardar"
      description="Está seguro de guardar el menú para este usuario?"
      type="Warning"
      ref="dialogUser"
      :callback="getItemsSelected"
    />
  </el-container>
</template>
<script>
  import {
    getUsers,
    saveMenuByUser,
    getMenuByUser,
    getProfiles,
    getMenuByProfile
  } from '@/api/menu_build'
  import Build from '@/components/Menu/Build.vue'
  import DialogConfirm from '@/components/dialog/DialogConfirm.vue'
  export default {
    data() {
      return {
        arpe_id: localStorage.getItem('profile'), // Perfil de usuario que inicia sesion
        users: [],
        usersOptions: [],
        profileOptions: [],
        menu: [],
        selectedItems: [],
        isUserProfile: false,
        form: {
          usua_id: null,
          arpe_id: null
        },
        rules: {
          usua_id: [
            {
              required: true,
              message: 'Este campo es requerido.',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    components: {
      Build,
      DialogConfirm
    },
    methods: {
      isProfile(value) {
        const arpe_id = this.usersOptions.find(user => user.usua_id === value)
          .arpe_id
        if (arpe_id) {
          this.isUserProfile = true
          this.form.arpe_id = arpe_id
        } else {
          this.form.arpe_id = null
          this.isUserProfile = false
        }
      },
      onsubmit() {
        this.$refs.formUser.validate(valid => {
          if (valid) {
            this.$refs.dialogUser.open()
          } else {
            return false
          }
        })
      },
      getItemsSelected() {
        this.selectedItems = []

        // Función recursiva para obtener todos los elementos seleccionados
        const getSelectedItems = items => {
          return items
            .map(item => {
              if (item.selected) {
                const newItem = { ...item }
                if (item.children && item.children.length > 0) {
                  newItem.children = getSelectedItems(item.children).filter(
                    child => child.selected
                  )
                }
                return newItem
              } else if (item.children && item.children.length > 0) {
                const selectedChildren = getSelectedItems(item.children).filter(
                  child => child.selected
                )
                if (selectedChildren.length > 0) {
                  return { ...item, children: selectedChildren }
                }
              }
              return null
            })
            .filter(item => item !== null)
        }

        // Obtener todos los elementos seleccionados
        this.selectedItems.push(...getSelectedItems(this.menu))

        if (this.selectedItems.length === 0) {
          this.$message({
            message: 'No se ha seleccionado ningún elemento',
            type: 'warning'
          })
          return
        }
        this.saveMenuUser()
      },
      async saveMenuUser() {
        const response = await saveMenuByUser(
          this.menu,
          this.form.usua_id,
          this.form.arpe_id
        )
        if (response.status === 200) {
          this.$message({
            message: 'Menú guardado correctamente',
            type: 'success'
          })
        } else {
          this.$message({
            message: 'Error al guardar el menú',
            type: 'error'
          })
        }
      },
      loadMenu() {
        getMenuByUser(this.form.usua_id, this.arpe_id).then(async response => {
          this.menu = []
          if (response.data) {
            this.menu = response.data
          }
        })
      },
      loadMenuByProfile() {
        getMenuByProfile(this.form.arpe_id, this.arpe_id).then(
          async response => {
            this.menu = []
            if (response.data) {
              this.menu = response.data
            }
          }
        )
      }
    },
    async created() {
      const users = await getUsers(this.arpe_id)
      this.usersOptions = users.data

      const profiles = await getProfiles(this.arpe_id)
      this.profileOptions = profiles.data
    },
    watch: {
      'form.usua_id': {
        handler: function(e) {
          if (e) {
            this.loadMenu()
          }
        },
        immediate: true
      }
    }
  }
</script>
<style lang="scss" scoped>
  .demo-form-inline .el-input {
    --el-input-width: 220px;
  }

  .demo-form-inline .el-select {
    --el-select-width: 220px;
  }
</style>
